<template>
  <div class="fix_box">
    <div class="fix_content">
      <div class="top_content">
        <span class="baozhang">全面保障</span>
        <van-icon size="30" name="close" @click="closeBox" />
      </div>
      <div class="list_box">
        <div class="list_box_scroll">
          <div v-for="(item, i) in productList" :key="i" class="flex_wrap">
            <div class="imgsrc" :style="item.flag ? '' : 'opacity: 0.6'">
              <img :src="item.imgSrc" alt="">
            </div>
            <p>{{ item.productName }}</p>
            <div class="list_bottom">
              <span style="display:flex;"><span class="font-size">保费：</span><span class="font-size" style="font-size:0.14rem;font-weight:bold;color:#F29600;">{{ item.price }}元起</span></span>
              <van-checkbox v-model="item.flag" checked-color="#5e2589" class="border-style-checkbox" @change="checkProduct($event, item)" />
            </div>
          </div>
          <div class="sure">
            <span @click="sureList">确定</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/api/api.js'
import { Toast } from 'vant'
// import { mapGetters } from 'vuex'
export default {
  props: {
    startTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      productList: [],
      arrowImgPath: api.imgAllUrl + '/back-arrow-20200506.png'
    }
  },
  computed: {
    productXInfoDTOLists() {
      return this.$store.state.productXInfoDTOList
    }
  },
  watch: {
    productXInfoDTOLists: {
      deep: true,
      handler(newVal, oldVal) {
        console.log(newVal, 'newValnewValnewValnewVal')
        this.productList = newVal
      }
    }
  },
  mounted() {
    this.productList = this.productXInfoDTOLists
    // this.queryProduct()
  },
  methods: {
    checkProduct(e, item) {
      if (e) {
        const param = {
          insuredInfoDtos: [{
            endDate: this.endTime.substr(0, 10),
            identityNumber: this.$store.state.recognizeeIn.identifyNumber,
            identityType: this.$store.state.recognizeeIn.identifyType,
            insuredName: this.$store.state.recognizeeIn.insuredName,
            riskCode: item.riskCode,
            startDate: this.startTime.substr(0, 10)
          }]
        }
        this.$http.post(api.checkNonCarProduct, param)
          .then((res) => {
            console.log('重复投保', res)
            if (res.data.rtnCode === '0000') {
              if (!res.data.insuredInfoResDtos[0].allowFlag) {
                Toast('被保人有重复投保或理赔记录，暂不支持投保')
                item.flag = false
              }
            } else {
              Toast('重复投保校验有误，请重试')
              item.flag = false
            }
          })
      }
    },
    closeBox() {
      this.$emit('product', false)
    },
    queryProduct() {
      // const params = {
      //   "isPersonal":"1",
      //   "businessNature":"2",
      //   "seatCount":"5",
      //   "useNature":"85"
      // }
      const params = {
        'isPersonal': this.$store.state.recognizeeIn.insuredNature === '4' ? '0' : '1',
        'businessNature': '2',
        'seatCount': this.$store.state.vehicleInfos.seatCount,
        'useNature': this.$store.state.vehicleInfos.useNatureCode
      }
      this.$http.post(api.queryProductList, params)
        .then((res) => {
          if (res.data.rtnCode === '0000') {
            res.data.productXInfoDTOList.forEach(ele => {
              ele.imgSrc = 'https://open.zking.com/cms/uploads/15/image/product' + ele.imgSrc
              ele.flag = false
              const planParam = {
                insuredType: this.$store.state.recognizeeIn.insuredNature === '4' ? '0' : '1',
                businessNature: '2',
                productCode: ele.productCode,
                seatCount: this.$store.state.vehicleInfos.seatCount,
                useNature: this.$store.state.vehicleInfos.useNatureCode
              }
              this.$http.post(api.queryProductPlanList, planParam)
                .then((response) => {
                  console.log(response, '1----')
                  if (response.data.rtnCode === '0000') {
                    ele.productPlanDTOList = response.data.productPlanDTOList
                  }
                })
            })
            if (this.productXInfoDTOList.length > 0) {
              this.productList = this.productXInfoDTOList
            } else {
              this.productList = res.data.productXInfoDTOList
            }
          }
        })
    },
    sureList() {
      this.$store.commit('set_productXInfoDTOList', this.productList)
      this.$emit('product', false)
      console.log(this.productList, 'this.productListthis.productListthis.productList')
      // this.productList.forEach
    }
  }
}
</script>
<style lang="scss" scoped>
  .fix_box{
    top: 0;
    left: 0;
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1000;
    background: rgba($color: #000000, $alpha: 0.3);
    .fix_content{
      width: 100%;
      position: fixed;
      bottom: 54px;
      background-color: #F7F6F9;
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
    }
    .list_box{
      height: 500px;
      overflow: scroll;
    }
    .list_box_scroll{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
    }
    .sure{
        background-color: #fff;
        position: fixed;
        width: 100%;
        height: 54px;
        bottom: 0;
        display: flex;
        justify-content: center;
        span{
          display: inline-block;
          font-size: 16px;
          width: 272px;
          color: #fff;
          height: 40px;
          line-height: 40px;
          background-color: #5E2589;
          margin-top: 6px;
          text-align: center;
          border-radius: 24px;
        }
      }
    .flex_wrap{
      width: 170px;
      background-color: #fff;
      border-radius: 8px;
      margin-bottom: 10px;
      padding-bottom: 10px;
      // margin-left: 25px;
      .imgsrc{
        margin-bottom: 12px;
        display: flex;
        justify-content: center;
        img{
          width: 168px;
          height: 168px;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;
        }
      }
      p{
        font-size: 14px;
        font-weight: bold;
        margin: 0;
        text-align: center;
        height: 40px;
      }
      .list_bottom{
        display: flex;
        justify-content: space-around;
        .font-size{
          font-size: 12px;
        }
      }
      /deep/ .mint-cell:last-child {
        background-image: linear-gradient(0deg, #fff, #fff 50%, transparent 50%);
      }
      /deep/ .mint-cell-wrapper {
        background-image: linear-gradient(0deg, #fff, #fff 50%, transparent 50%);
      }
      /deep/ .min-height{
        min-height: 0px;
      }
    }
  }
  .top_content{
    padding: 14px 25px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
  }
  .baozhang{
    display: inline-block;
    font-size: 14px;
    color: #333333;
    line-height: 30px;
    border-left: 6px solid #5E2589;
    text-indent: 6px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/pages/car/components/productList.vue